import AuthLayout from "../../layouts/Auth.layout";
import { AuthWrapper, ForgotPasswordForm } from "../../components/forms/auth";
import { BackBtn } from "../../components/forms/auth";

export const Recovery = () => {
  return (
    <AuthLayout>
      <BackBtn className="md:absolute top-0" />
      <AuthWrapper form={<ForgotPasswordForm />}>
        <div className="font-poppins text-5xl	text-gray-500 mb-8">
          Forgot
          <br />
          password?
        </div>
        <div className="font-manrope text-base text-gray-300 flex flex-row gap-x-6">
          No worries. We'll send you a recovery link.
        </div>
      </AuthWrapper>
    </AuthLayout>
  );
};
